import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { getProductFamilies } from '../../../api/resilience/resilience.api';
import type { ProductFamily } from '../types';
import { DEFAULT_CACHE_TIME_MS, DEFAULT_STALE_TIME_MS } from '../constant';
import { useIsoLanguageCode } from '../../../utils/hooks/useIsoLanguageCode';

export function useProductFamilies() {
  const isoLanguageCode = useIsoLanguageCode();

  return useQuery<ProductFamily[], AxiosError>({
    queryKey: ['/v1/configurator/product-families', { isoLanguageCode }],
    queryFn: async (): Promise<ProductFamily[]> => {
      const res = await getProductFamilies({
        params: {
          isoLanguageCode,
        },
      });
      return res.data;
    },
    enabled: !!isoLanguageCode,
    staleTime: DEFAULT_STALE_TIME_MS,
    cacheTime: DEFAULT_CACHE_TIME_MS,
  });
}
